module.exports = __webpack_public_path__ + "img/c1@2x.6aa36cb4.png";